module.exports = __webpack_public_path__ + "img/ffBanner_MO.2e923aad.jpg";